import axios from 'axios';
import config from './../../../public/config';

const state = {
  courses: [],
  courseDetails: null,
  categories: [],
  confirmation: {},
  uploadedFile: null,
  thumbnailPath: null,
  comments: [],
  quizes: []
};

const getters = {
  getCourses: (state) => state.courses,
  getCourseDetails: (state) => state.courseDetails,
  getCategories: (state) => state.categories,
  getConfirmation: (state) => state.confirmation,
  getUploadedFile: (state) => state.uploadedFile,
  getThumbnailPath: (state) => state.thumbnailPath,
  getComments: (state) => state.comments,
  getQuizes: (state) => state.quizes
};

const actions = {
  fetchCourses({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.hostname}/api/Course/GetCourseList`)
        .then((response) => {
          commit('setCourses', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchCourseQuizzes ({commit},obj) {
    return new Promise((resolve,reject)=>{
        axios.get(config.hostname+`/api/Course/GetCourseQuizzes?email=${obj.email}&courseId=${obj.courseId}`)
        .then((response)=>{
            commit('setQuizes',response.data)
            resolve(response)
        })
        .catch((error)=>{
            reject(error)
        })
    })
},

  deleteComment({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.hostname}/api/Course/DeleteComment/${obj.courseId}/Comments/${obj.commentId}`)
        .then((response) => {
          commit('setConfirmation', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchComments({ commit }, courseId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.hostname}/api/Course/GetComments/${courseId}/Comments`)
        .then((response) => {
          commit('setComments', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addComment({ commit }, commentData) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.hostname}/api/Course/AddComment/${commentData?.courseId}/Comments`, commentData)
        .then((response) => {
          commit('setConfirmation', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchCourseById({ commit }, courseId) {
    console.log('Fetching course with ID:', courseId);
    
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.hostname}/api/Course/GetCourseById/${courseId}`)
        .then((response) => {
          console.log('Full Axios Response:', response);
          
          // Ensure response.data exists and is not undefined
          if (response && response.data) {
            commit('setCourseDetails', response.data);
            resolve(response);
          } else {
            console.error('Invalid response structure');
            reject(new Error('Invalid response from server'));
          }
        })
        .catch((error) => {
          console.error('Detailed Fetch Course Details Error:', {
            message: error.message,
            response: error.response,
            request: error.request
          });
          reject(error);
        });
    });
  },

  fetchCategories({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.hostname}/api/Course/GetCourseCategories`)
        .then((response) => {
          commit('setCategories', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  createCourse({ commit }, course) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.hostname}/api/Course/CreateCourse`, course)
        .then((response) => {
          commit('setConfirmation', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateCourse({ commit }, course) {
    // if (this.$refs.form.validate()) {
      this.saving = true;
      
      // Add these logs
      console.log('Course before update:', course);
      console.log('Course ID:', course.courseId);
      console.log('Course ID type:', typeof course.courseId);

      try {
        return new Promise((resolve, reject) => {
          axios
            .put(`${config.hostname}/api/Course/UpdateCourse/${course.courseId}`, course)
            .then((response) => {
              commit('setConfirmation', response.data);
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
      catch (error) {
        console.error('Error updating course:', error);
        this.saving = false;
      }
    // }

    
  },

  deleteCourse({ commit }, courseId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.hostname}/api/Course/DeleteCourse/${courseId}`)
        .then((response) => {
          commit('setConfirmation', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  createModule({ commit }, moduleData) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.hostname}/api/Module/CreateModule`, moduleData)
        .then((response) => {
          // Update local state with the new module if needed
          if (response.data) {
            commit('addModule', response.data);
          }
          resolve(response);
        })
        .catch((error) => {
          console.error('Error creating module:', error);
          reject(error);
        });
    });
  },

  updateModule({ commit }, moduleData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.hostname}/api/Module/UpdateModule/${moduleData.moduleId}`, moduleData)
        .then((response) => {
          // Update local state with the new module if needed
          if (response.data) {
            commit('addModule', response.data);
          }
          resolve(response);
        })
        .catch((error) => {
          console.error('Error creating module:', error);
          reject(error);
        });
    });
  },

  deleteModule({ commit }, moduleId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.hostname}/api/Module/DeleteModule/${moduleId}`)
        .then((response) => {
          commit('setConfirmation', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  createModuleContent({ commit }, contentData) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.hostname}/api/Module/CreateModuleContent`, contentData)
        .then((response) => {
          if (response.data) {
            commit('addModuleContent', response.data);
          }
          resolve(response);
        })
        .catch((error) => {
          console.error('Error creating module content:', error);
          reject(error);
        });
    });
  },

  updateModuleContent({ commit }, contentData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.hostname}/api/Module/UpdateModuleContent/content/${contentData.moduleContentId}`, contentData)
        .then((response) => {
          if (response.data) {
            commit('addModuleContent', response.data);
          }
          resolve(response);
        })
        .catch((error) => {
          console.error('Error creating module content:', error);
          reject(error);
        });
    });
  },

  deleteModuleContent({ commit }, moduleContentId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.hostname}/api/Module/DeleteModuleContent/content/${moduleContentId}`)
        .then((response) => {
          commit('setConfirmation', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  uploadModuleFiles({ commit }, fileData) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.hostname}/api/Module/UploadModuleFiles`, fileData)
        .then((response) => {
          commit('setUploadedFiles', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  
  // createModuleContent({ commit }, contentData) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .post(`${config.hostname}/api/Module/CreateModuleContent/content`, contentData)
  //       .then((response) => {
  //         // Update local state with the new module content if needed
  //         if (response.data) {
  //           commit('addModuleContent', response.data);
  //         }
  //         resolve(response);
  //       })
  //       .catch((error) => {
  //         console.error('Error creating module content:', error);
  //         reject(error);
  //       });
  //   });
  // },

  uploadCourseFile({ commit }, fileData) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.hostname}/api/Course/UploadCourseFile`, fileData)
        .then((response) => {
          commit('setUploadedFile', response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  uploadCourseThumbnail({commit}, objFormData) {
    console.log('Starting thumbnail upload');
    return new Promise((resolve, reject) => {
        axios.post(`${config.hostname}/api/Course/UploadCourseThumbnail`, objFormData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {
            console.log('Upload success:', response);
            if (response.data && response.data.dbPath) {
                commit('imageUpload', response.data);
                resolve(response);
            } else {
                console.error('Invalid response structure:', response);
                reject(new Error('Invalid response structure'));
            }
        })
        .catch((error) => {
            console.error('Upload error:', error);
            if (error.response) {
                console.error('Error response:', error.response.data);
            }
            reject(error);
        });
    });
},
};

const mutations = {
  setCourses: (state, courses) => {
    state.courses = courses;
  },
  setQuizes: (state, quizes) => {
    state.quizes = quizes;
  },
  setComments: (state, comments) => {
    state.comments = comments;
  },
  setCategories: (state, categories) => {
    state.categories = categories;
  },
  setConfirmation: (state, confirmation) => {
    state.confirmation = confirmation;
  },
  setCourseDetails: (state, courseDetails) => {
    state.courseDetails = courseDetails;
  },
  setUploadedFile: (state, uploadedFile) => {
    state.uploadedFile = uploadedFile;
  },
  imageUpload: (state, data) => {
    state.thumbnailPath = data.dbPath
  },
  addModule: (state, module) => {
    if (state.courseDetails && state.courseDetails.modules) {
      state.courseDetails.modules.push(module);
    }
  },
  
  addModuleContent: (state, content) => {
    if (state.courseDetails && state.courseDetails.modules) {
      const targetModule = state.courseDetails.modules.find(m => m.moduleId === content.moduleId);
      if (targetModule) {
        if (!targetModule.content) {
          targetModule.content = [];
        }
        targetModule.content.push(content);
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};